var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPadlockFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00405 0C5.57653 0 3.25421 1.53789 3.25421 4.8281V6.85397C2.42077 7.00185 2 7.5342 2 8.51017V14.2847C2 15.4603 2.59069 16 3.77208 16H12.236C13.4255 16 14 15.4603 14 14.2847V8.51017C14 7.5268 13.5873 6.98706 12.7539 6.84658V4.8281C12.7539 1.53789 10.4235 0 8.00405 0ZM5.38281 4.71719C5.38281 2.80221 6.58848 1.87061 8.00453 1.87061C9.42057 1.87061 10.6262 2.80221 10.6262 4.71719V6.80961H5.38281V4.71719Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPadlockFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PadlockFilled.4c0d198de317b44b422eceff0b4e4c31.svg";